import React from 'react'

// const searchButtonStyle = { width: '60%', height: 42, padding: 0, margin: '10px 5px 30px 20px' }
// const actionButtonStyle = { width: 80, height: 30, padding: 0, marginLeft: 5 }

const TicketsTableComponent = (props) => {
  return (
    <div className="row etm-tickets-table-wrp">
      <table className="payout-table">
        <thead>
          <tr className="payout-table-header">
            <th>Ticket no</th>
            <th>Source Stage</th>
            <th>Destination Stage</th>
            <th>Timestamp</th>
            <th>Passengers</th>
            <th>Total Fare Collected</th>
          </tr>
        </thead>
        <tbody>
          {
            !props.tableData.length && <tr><td colSpan={6} className="table-no-data">No Data Found</td></tr>
          }
          {
            props.tableData.map((el, i) => {
              return(
                el.ticketInfo && el.ticketInfo.map(ticket => (
                  <tr key={ticket.ticketId} className="payout-table-row">
                    <td>{ticket.ticketId}</td>
                    <td>{ticket.sourceName || '-'}</td>
                    <td>{ticket.destinationName || '-'}</td>
                    <td>{ticket.createdAt || '-'}</td>
                    <td>{ticket.paxInfo && ticket.paxInfo.length? ticket.paxInfo.reduce((sum, item) => sum + item.count, 0): '-'}</td>
                    <td>{ticket.totalFare || '-'}</td>
                  </tr>
                ))
              )
            })
          }
        </tbody>
      </table>
    </div>
  )
}

export default TicketsTableComponent